import React, { useState } from 'react';
import {  
    Table, 
    Card, 
    Row, 
    Col, 
    Statistic, 
    Input, 
    Select, 
    DatePicker, 
    Button, 
    Space, 
    Tag, 
    Alert
, Typography } from 'antd';
import { 
    SearchOutlined, 
    ReloadOutlined, 
    ExportOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

const DeviceList = () => {
    const navigate = useNavigate();
    const [loading] = useState(false);

    // 统计数据
    const stats = [
        { title: '设备总数', value: 6, color: '#1890ff' },
        { title: '已被绑定', value: 2, color: '#52c41a' },
        { title: '当前在线设备', value: 4, color: '#fa8c16' },
    ];

    // 搜索表单状态
    useState({
        region: 'china',
        license: '',
        productName: '',
        userBind: 'all',
        firmwareVersion: ''
    });

    // 模拟表格数据
    const dataSource = [
        {
            key: '1',
            license: 'JpxTTR260206fGYa',
            firmware: '25.11.13.1',
            productName: '普通单目云台摄像机',
            productId: 'P5xJS90pll',
            bindStatus: '已绑定',
            firstBind: '2026-02-06 15:46:26',
            lastBind: '2026-02-06 13:57:47',
        },
        {
            key: '2',
            license: '010HMP251113oDRv',
            firmware: '25.11.13.1',
            productName: 'N2普通云台摄像机',
            productId: 'PfmULRthXq',
            bindStatus: '未绑定',
            firstBind: '-',
            lastBind: '-',
        },
        {
            key: '3',
            license: '010HMP251113cUbT',
            firmware: '25.11.13.1',
            productName: 'N2普通云台摄像机',
            productId: 'PfmULRthXq',
            bindStatus: '未绑定',
            firstBind: '-',
            lastBind: '-',
        },
        {
            key: '4',
            license: '010HMT251111Y8Ld',
            firmware: '-',
            productName: '普通单目云台摄像机',
            productId: 'P5xJS90pll',
            bindStatus: '未绑定',
            firstBind: '-',
            lastBind: '-',
        },
        {
            key: '5',
            license: '010HMT251111pN9E',
            firmware: '-',
            productName: '普通单目云台摄像机',
            productId: 'P5xJS90pll',
            bindStatus: '已绑定',
            firstBind: '2025-12-30 14:56:29',
            lastBind: '2026-01-05 10:43:28',
        },
        {
            key: '6',
            license: 'T8HHMY2503270051',
            firmware: '-',
            productName: '普通单目云台摄像机',
            productId: 'P5xJS90pll',
            bindStatus: '未绑定',
            firstBind: '-',
            lastBind: '-',
        }
    ];

    const columns = [
        {
            title: 'License',
            dataIndex: 'license',
            key: 'license',
            width: 180,
        },
        {
            title: '固件版本',
            dataIndex: 'firmware',
            key: 'firmware',
            width: 120,
            render: (text) => text === '-' ? <span style={{ color: '#ccc' }}>-</span> : text
        },
        {
            title: '产品信息',
            dataIndex: 'productName',
            key: 'productName',
            render: (text, record) => (
                <div>
                    <div style={{ fontWeight: 500 }}>{text}</div>
                    <div style={{ fontSize: '12px', color: '#999' }}>{record.productId}</div>
                </div>
            )
        },
        {
            title: '公版SaaS',
            dataIndex: 'bindStatus',
            key: 'bindStatus',
            width: 100,
            render: (status) => (
                <Tag color={status === '已绑定' ? 'success' : 'error'}>
                    {status}
                </Tag>
            )
        },
        {
            title: '首次绑定',
            dataIndex: 'firstBind',
            key: 'firstBind',
            render: (text) => text === '-' ? <span style={{ color: '#ccc' }}>-</span> : text
        },
        {
            title: '最后绑定',
            dataIndex: 'lastBind',
            key: 'lastBind',
            render: (text) => text === '-' ? <span style={{ color: '#ccc' }}>-</span> : text
        },
        {
            title: '操作',
            key: 'action',
            width: 100,
            render: (_, record) => (
                <Button type="link" size="small" onClick={() => navigate(`/device/info?license=${record.license}`)}>查看详情</Button>
            ),
        },
    ];

    return (
        <div style={{ padding: '0px' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>我的设备</Title>
      </div>
            <Alert
                message="设备列表页数据可能会存在一定的数据同步延迟，如需查看设备精准信息，请前往设备详细中查看！"
                type="info"
                showIcon
                closable
                style={{ marginBottom: 16 }}
            />

            {/* 统计区域 */}
            <Row gutter={16} style={{ marginBottom: 24 }}>
                <Col span={6}>
                    <Card bodyStyle={{ padding: '16px 24px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <div style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: '14px', marginBottom: 12 }}>设备节点</div>
                        <Select 
                            defaultValue="all" 
                            style={{ width: '100%' }} 
                            dropdownStyle={{ minWidth: 120 }}
                        >
                            <Option value="all">全部节点</Option>
                            <Option value="china">国内节点</Option>
                            <Option value="oversea">亚太节点</Option>
                            <Option value="bxmz">北美节点</Option>
                        </Select>
                    </Card>
                </Col>
                {stats.map((item, index) => (
                    <Col span={6} key={index}>
                        <Card bodyStyle={{ padding: '20px 24px' }}>
                            <Statistic 
                                title={<span style={{ color: '#666' }}>{item.title}</span>}
                                value={item.value} 
                                valueStyle={{ color: item.color, fontWeight: 'bold', textAlign: 'center' }}
                                style={{ textAlign: 'center' }}
                            />
                        </Card>
                    </Col>
                ))}
            </Row>

            {/* 搜索区域 */}
            <Card style={{ marginBottom: 16 }}>
                <Form layout="inline" style={{ gap: '16px 24px' }}>
                    <Space size="middle" wrap>
                        <Input.Group compact>
                            <Select defaultValue="License" style={{ width: 100 }}>
                                <Option value="License">License</Option>
                                <Option value="DID">设备DID</Option>
                            </Select>
                            <Input style={{ width: 180 }} placeholder="请输入" />
                        </Input.Group>

                        <Input.Group compact>
                            <Select defaultValue="ProductName" style={{ width: 100 }}>
                                <Option value="ProductName">产品名称</Option>
                                <Option value="ProductId">产品ID</Option>
                            </Select>
                            <Input style={{ width: 180 }} placeholder="请输入内容" />
                        </Input.Group>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ marginRight: 8, color: '#666' }}>公版SaaS</span>
                            <Select defaultValue="all" style={{ width: 120 }}>
                                <Option value="all">全部</Option>
                                <Option value="bind">已绑定</Option>
                                <Option value="unbind">未绑定</Option>
                            </Select>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ marginRight: 8, color: '#666' }}>固件版本号</span>
                            <Select placeholder="请选择固件版本号" style={{ width: 180 }} allowClear>
                                <Option value="v1">25.11.13.1</Option>
                            </Select>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ marginRight: 8, color: '#666' }}>首次绑定</span>
                            <RangePicker style={{ width: 260 }} />
                        </div>

                        <Space>
                            <Button type="primary" icon={<SearchOutlined />}>搜索</Button>
                            <Button icon={<ReloadOutlined />}>重置</Button>
                            <Button type="primary" ghost icon={<ExportOutlined />} style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: '#fff' }}>导出</Button>
                        </Space>
                    </Space>
                </Form>
            </Card>

            {/* 表格区域 */}
            <Card bodyStyle={{ padding: 0 }}>
                <Table 
                    columns={columns} 
                    dataSource={dataSource} 
                    loading={loading}
                    pagination={{
                        total: 6,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: (total) => `共${total}条记录`,
                        defaultPageSize: 10,
                        size: 'small'
                    }}
                />
            </Card>
        </div>
    );
};

// 简单的 Form 模拟，因为这里没 import Form
const Form = ({ children, layout, style }) => <div style={{ ...style, display: 'flex', flexWrap: 'wrap' }}>{children}</div>;

export default DeviceList;
